import React from 'react';

const isEmpty = (value) => !value;

/* eslint-disable camelcase */

const getVehicleNicknameLicensePlate = (
  nickname,
  license_plate
) => {
  let vehicleNicknameLicensePlate = '';

  if (nickname && license_plate) {
    vehicleNicknameLicensePlate = `${nickname} (${license_plate})`;
  } else if (nickname) {
    vehicleNicknameLicensePlate = nickname;
  } else if (license_plate) {
    vehicleNicknameLicensePlate = license_plate;
  }

  return vehicleNicknameLicensePlate;
};

// eslint-disable-next-line react/function-component-definition, react/prop-types
const VehicleNicknameLicensePlateLink = ({ vehicle }) => {
  const { nickname, license_plate, id } = vehicle || {};
  const vehicleNicknameLicensePlate = getVehicleNicknameLicensePlate(nickname, license_plate);
  const value = vehicleNicknameLicensePlate;
  const displayValue = (
    <a href={`../vehicles/${id}` || ''} className="w-100 text-truncate">
      <span className="text-truncate">{vehicleNicknameLicensePlate}</span>
    </a>
  );
  return (
    <span title={vehicleNicknameLicensePlate} className="flex items-center gap-2">
      {isEmpty(displayValue) ? value : displayValue}
    </span>
  );
};

export default VehicleNicknameLicensePlateLink;
